import { BaseService } from '../base/BaseService';
export class AiContentService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AiContentService.DEFAULT_SERVICE_PATH,
            basePath: AiContentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async generateRaw(request) {
        return this.http.post(this.buildUrl('generate'), request);
    }
    async generate(request) {
        const response = await this.generateRaw(request);
        if (!response.data)
            throw new Error('No data returned from content generation');
        return response.data;
    }
    async summarizeRaw(request) {
        return this.http.post(this.buildUrl('summarize'), request);
    }
    async summarize(request) {
        const response = await this.summarizeRaw(request);
        if (!response.data)
            throw new Error('No data returned from summarization');
        return response.data;
    }
    async improveRaw(request) {
        return this.http.post(this.buildUrl('improve'), request);
    }
    async improve(request) {
        const response = await this.improveRaw(request);
        if (!response.data)
            throw new Error('No data returned from text improvement');
        return response.data;
    }
}
AiContentService.DEFAULT_SERVICE_PATH = 'ai-management';
AiContentService.BASE_PATH = 'api/ai/content';
//# sourceMappingURL=AiContentService.js.map